class NavColour extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isDesktopMode = window.BAO.MediaBreakpoints.isMd
  }

  setupListeners () {
    super.setupListeners()

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.onViewportChange = this.onViewportChange.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )

    if (this.isDesktopMode) {
      this.initDesktopListeners()
    }
  }

  initDesktopListeners () {
    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.add(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  removeDesktopListeners () {
    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.remove(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.remove(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  onViewportChange ({ detail }) {
    const newIsDesktop =
      detail.currentBreakpoint !== 'xxs' && detail.currentBreakpoint !== 'xs'

    if (newIsDesktop && !this.isDesktopMode) {
      this.isDesktopMode = true
      this.initDesktopListeners()
    } else if (!newIsDesktop && this.isDesktopMode) {
      this.isDesktopMode = false
      this.removeDesktopListeners()
    }
  }

  handleMouseEnter (e) {
    this.els.name.element.textContent = e.currentTarget.dataset.name
  }

  handleMouseLeave () {
    this.els.name.element.textContent = ''
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )
  }
}

if (!customElements.get('nav-colour')) {
  customElements.define('nav-colour', NavColour)
}
